export default "__VITE_ASSET__CcxEo3gg__"